import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

class ViewRefused extends Component {
    state = {
        visible: false,
        loading: false,
        data: [], 
    }

    show = (id) => {
        this.setState({ visible: true }, () => {
            this.loadData(id);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    };

    loadData = requirementId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryReturnRecords,
            data: { requirementId },
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data.returnList,
                });
            },
            errorResult: () => {
                this.setState({ loading : false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    getColumns = () => [{
        title: '打回时间',
        dataIndex: 'createTime',
        key: 'createTime',
    }, {
        title: '打回原因',
        dataIndex: 'remark',
        key: 'remark',
    }, {
        title: '操作人',
        dataIndex: 'user',
        key: 'user',
    }]

    getDataSource = () => {
        const { data } = this.state;

        const dataSource = (data || []).map(item => {
            const { createTime, user, remark } = item;
            return {
                createTime,
                user,
                remark
            };
        });

        return dataSource;
    }

    render() {
        const {visible, loading } = this.state;
        return (
            <Modal
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width="1000px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button key="back" type="primary" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ textAlign: 'center' }}>
                    <label style={{ fontSize: '16px' }}>查看打回记录</label>
                </div>
                <br/>
                <br/>
                <hr/>
                <div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.requirementTransactionId}
                        pagination={false}
                        loading={loading}
                        bordered
                    />
                </div>
            </Modal>


        );
    }
}

export default ViewRefused;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/ViewRefused.js